import { take } from 'rxjs';
import { responseHandler } from '../../../../shared/responseHandler/responseHandler';
import { ITabState } from '../../overview/states/tabState.model';
import { OverviewArticlesRes, overviewService } from '../../services/overview.service';
import {
  concatArticleNameAndNo,
  getInitSortModel,
} from '../../overview/components/tabs/articles/articlesOverview.state.tsx';
import { dataHelper } from '../../../../shared/helpers/data/data.helper';

export async function resolveDataForArticleOverviewTab(tabState: ITabState): Promise<ITabState> {
  const { datePeriod, deliveryNoteGroupId } = tabState;

  let list: OverviewArticlesRes = await overviewService.globHelpers.streamToPromise(
    overviewService.sub.getOverviewArticles().pipe(
      responseHandler<OverviewArticlesRes>({
        customErrorHandler: () => 'order.tab_not_loaded',
        errorReturnType: [],
      }),
      take(1),
    ),
    () => {
      overviewService.pub.getOverviewArticles({
        filter: {
          periodStart: datePeriod?.fromDate,
          periodEnd: datePeriod?.toDate,
          deliveryNoteGroupId,
        },
      });
    },
  );

  const initSortModel = getInitSortModel();

  if (list?.length) {
    list = dataHelper
      .data(list as [])
      .sort({ sortModel: initSortModel })
      .result() as OverviewArticlesRes;
  }

  return { ...tabState, defaultValues: concatArticleNameAndNo(list) };
}
